import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree, Router } from '@angular/router';
import { filter, Observable, take } from 'rxjs';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';
import { UserState } from '../states/user.state';

@Injectable({
  providedIn: 'root',
})
export class CountryGuard {
  private router = inject(Router);
  private store = inject(Store);
  private userCountry$: Observable<string> = this.store.select<string>(UserState.userCountry);

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | boolean {
    const allowedCountries: string[] = next.data.countries;
    if (!allowedCountries || !allowedCountries.length) {
      return true;
    }

    return this.userCountry$.pipe(
      filter((country: string) => !!country),
      take(1),
      map((country: string) => {
        if (allowedCountries.includes(country)) {
          return true;
        }
        return this.router.createUrlTree(['/home']);
      }),
    );
  }
}
